import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let App = class App extends Vue {
};
App = __decorate([
    Component
], App);
export default App;
